export default {
    dashboard: 'Dashboard',
    ideas: 'Ideas',
    experiments: 'Experiments',
    adAccounts: 'Ad Accounts',
    assessment: 'My Assessment',
    profile: 'Profile',
    logout: 'Log Out',
};
